import { SELECT_MAP_PROJECT } from 'constants/actions';
import { combineReducers } from '@reduxjs/toolkit';

const id = (state = null, action = {}) => {
  switch (action.type) {
    case SELECT_MAP_PROJECT:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  id,
});
